import { createSlice } from '@reduxjs/toolkit';

import { ApiResponse } from '../../../model';

import type { RoleState, SetRoleDataPayload } from './model';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: ApiResponse<RoleState> = {
  pageMeta: {
    page: 0,
    limit: 0,
    itemCount: 0,
    pageCount: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  },
  records: [],
  settings: undefined,
};

export const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setRoleData(state, action: PayloadAction<ApiResponse<SetRoleDataPayload>>) {
      state.settings = action.payload.settings ?? null;
      state.pageMeta = action.payload.data.pageMeta ?? state.pageMeta;
      state.records = action.payload.data.records;
    },
  },
});

export const { setRoleData } = adminSlice.actions;
export default adminSlice;
